import React, { Component } from "react";

export default class AgentActivity extends Component {
  render() {
    return (
      <div>
        <h2>lorem test test test test test test test </h2>
      </div>
    );
  }
}
